<template>
  <div class="contents">
    <div class="container-fluid">
      <div class="breadcrumb-main user-member justify-content-sm-between mb-3">
        <h4 class="text-capitalize fw-500 breadcrumb-title">
          <a @click="$router.go(-1)" style="cursor:pointer"><i class="fas fa-arrow-left"></i></a>
          &nbsp; Broadcast Produk
        </h4>
      </div>

      <div class="card p-4 border bg-white radius-xl">
        <h5>Kirim Promo Produk ke Banyak Kontak</h5>
        <form @submit.prevent="send">
          <label>Pilih Produk</label>
          <select v-model.number="form.product_id" class="form-control mb-3" required>
            <option :value="null">-- Pilih produk --</option>
            <option v-for="p in products" :key="p.id" :value="p.id">{{ p.name }} ({{ formatRupiah(p.price) }})</option>
          </select>

          <label>Template Pesan</label>
          <textarea v-model="form.template" class="form-control mb-2" rows="6" required
            :placeholder="defaultTemplate"></textarea>
          <small class="text-muted mb-3 d-block">
            Placeholder: <code>{nama}</code>, <code>{product_name}</code>, <code>{price}</code>, <code>{shop_name}</code>, <code>{product_link}</code>, <code>{description}</code>
          </small>

          <label>Daftar Kontak (1 per baris, format 08xxx atau 628xxx)</label>
          <textarea v-model="contactsRaw" class="form-control mb-3" rows="8" placeholder="08123456789&#10;08987654321"></textarea>

          <label>Delay Antar Pesan (detik)</label>
          <input v-model.number="form.delay_seconds" type="number" class="form-control mb-3" placeholder="30">
          <small class="text-muted">Recommended 30-60 detik untuk hindari banned WA.</small>

          <hr>
          <div class="alert alert-info">
            Total kontak: <b>{{ contacts.length }}</b> | Estimasi waktu: <b>{{ formatDuration(contacts.length * (form.delay_seconds || 0)) }}</b>
          </div>

          <button type="submit" class="btn btn-primary btn-block" :disabled="submitting || !form.product_id || contacts.length === 0">
            <span v-if="submitting" class="spinner-border spinner-border-sm mr-2"></span>
            🚀 Kirim Broadcast
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      shopId: null,
      products: [],
      submitting: false,
      contactsRaw: '',
      form: {
        product_id: null,
        template: 'Halo {nama} 👋\n\nAda produk baru di {shop_name}: *{product_name}*\n\nHarga spesial: *Rp {price}*\n\nLihat detail: {product_link}\n\nLangsung order ya 🙏',
        delay_seconds: 30,
      },
      defaultTemplate: 'Halo {nama}, ada produk baru: {product_name} cuma Rp {price}!',
    };
  },
  computed: {
    contacts() {
      return this.contactsRaw.split('\n').map(s => s.trim()).filter(Boolean);
    },
  },
  mounted() {
    this.shopId = this.$route.params.id;
    this.loadProducts();
  },
  methods: {
    async loadProducts() {
      try {
        const r = await axios.get('shop/' + this.shopId + '/products');
        this.products = r.data.data.products || [];
      } catch (e) { this.$toast.error('Gagal load produk'); }
    },
    async send() {
      if (this.contacts.length === 0) {
        this.$toast.error('Daftar kontak kosong');
        return;
      }
      if (!confirm('Kirim broadcast ke ' + this.contacts.length + ' kontak?')) return;
      this.submitting = true;
      try {
        const r = await this.$store.dispatch('shop/shop_broadcast', {
          id: this.shopId,
          payload: {
            product_id: this.form.product_id,
            template: this.form.template,
            contacts: this.contacts,
            delay_seconds: this.form.delay_seconds,
          },
        });
        this.$toast.success(r.data.message);
        this.contactsRaw = '';
      } catch (e) { this.$toast.error(e.response?.data?.message || 'Gagal'); }
      this.submitting = false;
    },
    formatRupiah(v) { return (v || 0).toLocaleString('id-ID'); },
    formatDuration(seconds) {
      const m = Math.floor(seconds / 60); const s = seconds % 60;
      return m > 0 ? `${m} menit ${s} detik` : `${s} detik`;
    },
  },
};
</script>
